var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"cchangelog",attrs:{"title":"Changelog","size":'modal-md',"saveNeeded":false}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.markdownToHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }